$(document).on('fetchedPrice', (event, itemId, node) => {
  // console.log(itemId);
  // console.log($(`[data-price-uvp-target="${itemId}"]`).get(0));
  // console.log(node);
  const target = $(`[data-price-uvp-target="${itemId}"]`).get(0);
  if (target !== undefined) {
    target.innerHTML = $(node).find('[data-price-uvp]').get(0).innerHTML;
  }
});
